import { Avatar, type AvatarProps } from '@mantine/core';

import { getAvatarColor, getInitials } from './avatar';

export function UserAvatar({
    name,
    ...props
}: Readonly<{ name: string } & Omit<AvatarProps, 'name' | 'color' | 'variant' | 'children' | 'src' | 'vars'>>) {
    const background = getAvatarColor(name);
    return (
        <Avatar
            variant="filled"
            vars={() => ({ root: { '--avatar-bg': background, '--avatar-color': 'var(--color-static-white)' } })}
            {...props}
        >
            {getInitials(name)}
        </Avatar>
    );
}
